import { createReducer } from 'typesafe-actions'
import { ModelRecommendationsData } from '../../entities/ModelRecommendationsData'
import { setAiRecommendationsForModelData, resetAiRecommendationsForModelData } from '../actions/app/aiRecommendation.actions'

export type AiRecommendationsForModelDataState = ModelRecommendationsData

export const defaultState: AiRecommendationsForModelDataState = {
    recommendations: [],
}

const aiRecommendationsForModelDataReducer = createReducer(defaultState)
    .handleAction(setAiRecommendationsForModelData, (state, action) => action.payload)
    .handleAction(resetAiRecommendationsForModelData, () => defaultState)

export default aiRecommendationsForModelDataReducer
